import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import user from '../_helpers/user';

export default function AdminRoute({ component: Component, ...rest})
{
    return (
        <Route {...rest} render={props => (
            user.isAdmin
            ? <Component {...props} />
            : <Redirect to={{pathname: '/login', state: { from: props.location }} } />
        )} />
    )
}